module.exports = __webpack_public_path__ + "static/rundle-f758d0563b62341b5c76cc922c8c0525.png";